import React, { useEffect, useState, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  OverlayTrigger,
  Row,
  Toast,
  Tooltip
} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import {FaSearch} from 'react-icons/fa'
import { formato_monto } from '../../common/Formatos'



const CartaCIA = ({handleClose}) => {
  const data_traza_modal = useSelector((state) => state.trazabilidadReducer)
  const {datosGestion} = data_traza_modal
   const data_carta_cia = useSelector((state) => state.cartaCIAReducer)
   const { cfg_form25,datosImplicado} = data_carta_cia
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   
  return (
    <>
 <style type='text/css'>
      
    </style>
      
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form25
              ? cfg_form25.cfg_form25['consultacartaciatercero-title-carta']
              : ''} 
          </Card.Header>
          <Container>
           
            
              {cfg_form25? (
                <div >
                  
                  <Row >
                 
                    <Col md='3'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form25.cfg_form25[
                            'consultacartaciatercero-lbl-rut'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosImplicado &&
                datosImplicado.datosImplicado[0]['RutInvolucrado'] !== undefined &&
                datosImplicado.datosImplicado[0]['RutInvolucrado'] !== null &&
                datosImplicado.datosImplicado[0]['RutInvolucrado'] !== ''
                ? datosImplicado.datosImplicado[0]['RutInvolucrado']
                : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form25.cfg_form25[
                            'consultacartaciatercero-lbl-nombre'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosImplicado &&
                datosImplicado.datosImplicado[0]['NombreInvolucrado'] !== undefined &&
                datosImplicado.datosImplicado[0]['NombreInvolucrado'] !== null &&
                datosImplicado.datosImplicado[0]['NombreInvolucrado'] !== ''
                ? datosImplicado.datosImplicado[0]['NombreInvolucrado']
                : ''}
                </Form.Text>
                   </Col>
                    
                    
                  </Row>
                  
                  <Row>
                    <Col md='3'>
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form25.cfg_form25[
                            'consultacartaciatercero-lbl-tipovh'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosImplicado &&
                datosImplicado.datosImplicado[0]['TipoVehiculo'] !== undefined &&
                datosImplicado.datosImplicado[0]['TipoVehiculo'] !== null &&
                datosImplicado.datosImplicado[0]['TipoVehiculo'] !== ''
                ? datosImplicado.datosImplicado[0]['TipoVehiculo']
                : ''}
                </Form.Text>
                     
                    </Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form25.cfg_form25[
                            'consultacartaciatercero-lbl-patente'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosImplicado &&
                datosImplicado.datosImplicado[0]['Patente'] !== undefined &&
                datosImplicado.datosImplicado[0]['Patente'] !== null &&
                datosImplicado.datosImplicado[0]['Patente'] !== ''
                ? datosImplicado.datosImplicado[0]['Patente']
                : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form25.cfg_form25[
                            'consultacartaciatercero-lbl-marca'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosImplicado &&
                        datosImplicado.datosImplicado[0]['Marca'] !== undefined &&
                        datosImplicado.datosImplicado[0]['Marca'] !== null &&
                        datosImplicado.datosImplicado[0]['Marca'] !== ''
                        ? datosImplicado.datosImplicado[0]['Marca']
                        : ''}
                </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form25.cfg_form25[
                            'consultacartaciatercero-lbl-descripcion'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosImplicado &&
                        datosImplicado.datosImplicado[0]['Descripcion'] !== undefined &&
                        datosImplicado.datosImplicado[0]['Descripcion'] !== null &&
                        datosImplicado.datosImplicado[0]['Descripcion'] !== ''
                        ? datosImplicado.datosImplicado[0]['Descripcion']
                        : ''}
                </Form.Text>
                    </Col>
                        
                   
                  </Row>
                 
                  <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                  <Row >
                 
                 <Col md='2'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-ciaseguro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['CiaImplicado'] !== undefined &&
             datosImplicado.datosImplicado[0]['CiaImplicado'] !== null &&
             datosImplicado.datosImplicado[0]['CiaImplicado'] !== ''
             ? datosImplicado.datosImplicado[0]['CiaImplicado']
             : ''}
             </Form.Text>
                 </Col>
                 <Col md='3'>
                   <Form.Label
                     className='mt-4 mb-2'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-siniciatro'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['SiniestroIM'] !== undefined &&
             datosImplicado.datosImplicado[0]['SiniestroIM'] !== null &&
             datosImplicado.datosImplicado[0]['SiniestroIM'] !== ''
             ? datosImplicado.datosImplicado[0]['SiniestroIM']
             : ''}
             </Form.Text>
                </Col>
                <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-fechasinitro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['FechaSiniestroIMFormat'] !== undefined &&
             datosImplicado.datosImplicado[0]['FechaSiniestroIMFormat'] !== null &&
             datosImplicado.datosImplicado[0]['FechaSiniestroIMFormat'] !== ''
             ? datosImplicado.datosImplicado[0]['FechaSiniestroIMFormat ']
             : ''}
             </Form.Text>
                  
                 </Col>
                 <Col md='3'>
                   <Form.Label
                     className='mt-4 mb-2'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-fechaenvcarta'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['FechaEnvioCartaCobroFormat'] !== undefined &&
             datosImplicado.datosImplicado[0]['FechaEnvioCartaCobroFormat'] !== null &&
             datosImplicado.datosImplicado[0]['FechaEnvioCartaCobroFormat'] !== ''
             ? datosImplicado.datosImplicado[0]['FechaEnvioCartaCobroFormat']
             : ''}
             </Form.Text>
                 </Col>
                 <Col md='1'>
                   <Form.Label
                     className='mt-4 mb-2'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-vercta'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <OverlayTrigger 
                            overlay={<Tooltip id='tooltip-disabled'>Ver </Tooltip>}
                        >
                          <Button
                            type='button'
                            variant='secundary'
                            size='sm'
                            className='mx-3'>
                           <FaSearch size={25} style={{color:'gray'}}/>
                            
                          </Button>
                        </OverlayTrigger>
                   
                 </Col>
                 
               </Row>
               
               <Row >
               <Col md='2'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-moneda'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['GlosaMonedaLocal'] !== undefined &&
             datosImplicado.datosImplicado[0]['GlosaMonedaLocal'] !== null &&
             datosImplicado.datosImplicado[0]['CiaImplicado'] !== ''
             ? datosImplicado.datosImplicado[0]['GlosaMonedaLocal']
             : ''}
             </Form.Text>
                 </Col>
                 <Col md='3'>
                   <Form.Label
                     className='mt-4 mb-2'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-mtoneto'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['MontoCosto'] !== undefined &&
             datosImplicado.datosImplicado[0]['MontoCosto'] !== null &&
             datosImplicado.datosImplicado[0]['MontoCosto'] !== ''
             ? formato_monto(datosImplicado.datosImplicado[0]['MontoCosto'])
             : ''}
             </Form.Text>
                </Col>
                <Col md='3'>
                   <Form.Label
                     className='mb-2 mt-4'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-porcrecobro'
                       ]
                     }
                   </Form.Label>{' '}
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['PorConvenido'] !== undefined &&
             datosImplicado.datosImplicado[0]['PorConvenido'] !== null &&
             datosImplicado.datosImplicado[0]['PorConvenido'] !== ''
             ? datosImplicado.datosImplicado[0]['PorConvenido']
             : ''}
             </Form.Text>
                  
                 </Col>
                 <Col md='3'>
                   <Form.Label
                     className='mt-4 mb-2'
                     style={{ fontWeight: 'bold', fontSize: '16px' }}
                   >
                     {
                       cfg_form25.cfg_form25[
                         'consultacartaciatercero-lbl-mtorecobro'
                       ]
                     }
                   </Form.Label>
                   <br />
                   <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                     {datosImplicado &&
             datosImplicado.datosImplicado[0]['MontoRecobro'] !== undefined &&
             datosImplicado.datosImplicado[0]['MontoRecobro'] !== null &&
             datosImplicado.datosImplicado[0]['MontoRecobro'] !== ''
             ? formato_monto(datosImplicado.datosImplicado[0]['MontoRecobro'])
             : ''}
             </Form.Text>
                 </Col>
                
                     
                
               </Row>
               <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                </div>
              ) : null}
           
           <Row>
                <Col className='d-flex align-items-end justify-content-end m-2'>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
                {cfg_form25 && cfg_form25.cfg_form25["consultacartaciatercero-btn-cerrar"]}
                
          </Button>
          </Col>
           </Row>
     
      
   
          </Container>
        </Card>
     
     
    
    </>
  )
}

export default CartaCIA
